/* Cosmo pre-order
   When a product's stock is 0 (and "continue selling" is on), price.liquid prints
   an "Out of stock" label with a hidden .cosmo-preorder-flag.
   This script turns the matching Add to cart button into "Pre-order"
   and tags the cart line with "Pre-order: Yes" so it shows on the order. */
(function () {
  var PROP = 'properties[Pre-order]';
  var LABEL = '<span data-lang-only="en">Pre-order</span><span data-lang-only="ar">طلب مسبق</span>';

  function scopeOf(el) {
    return el.closest('.card-wrapper') || el.closest('product-info') || el.closest('.product') || el.closest('section');
  }

  function apply() {
    var flagged = [];
    document.querySelectorAll('.cosmo-preorder-flag').forEach(function (flag) {
      var scope = scopeOf(flag);
      if (!scope || flagged.indexOf(scope) !== -1) return;
      flagged.push(scope);

      scope.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (!form.querySelector('input[name="' + PROP + '"]')) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = PROP;
          input.value = 'Yes';
          form.appendChild(input);
        }
      });

      scope.querySelectorAll('.product-form__submit, .quick-add__submit').forEach(function (btn) {
        if (btn.closest('modal-opener') || btn.disabled) return;
        var span = btn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
        if (span && !span.querySelector('[data-lang-only]')) span.innerHTML = LABEL;
      });
    });

    // A product that is back in stock should not keep the pre-order tag
    document.querySelectorAll('input[name="' + PROP + '"]').forEach(function (input) {
      var form = input.closest('form');
      var scope = form && scopeOf(form);
      if (scope && flagged.indexOf(scope) === -1) input.remove();
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
